import { Form, InputGroup } from "react-bootstrap";

export default function ContactSearch({
  value,
  onChange,
  placeholder = "Search by name, phone or tag...",
}) {
  return (
    <InputGroup>
      <InputGroup.Text>
        <i className="bi bi-search"></i>
      </InputGroup.Text>

      <Form.Control
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </InputGroup>
  );
}
